import React, { useState } from 'react';
import {
  Grid, makeStyles, TextField, Typography, Button, useMediaQuery, Checkbox
} from '@material-ui/core';
import {
  Check as CheckIcon
} from '@material-ui/icons';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate, useParams } from 'react-router';

const useStyle = makeStyles(theme => ({
  jumbotron: {
    backgroundColor: 'rgb(48, 48, 48)',
    padding: 50,
    textAlign: 'center'
  },
  logoHolder: {
    backgroundColor: '#fff',
    overflow: 'hidden',
    marginBottom: 30
  },
  subHeading: {
    color: 'rgb(127, 176, 255)',
    marginTop: 5
  },
  section: {
    padding: 50
  },
  sectionLeftHeading: {
    color: 'rgb(47, 47, 47)',
    fontWeight: 600
  },
  formContainer: {
    border: '3px solid rgb(47, 47, 47)',
    dispaly: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    textAlign: 'center',
    padding: '40px 60px',
    width: 600,
    '& p, h4, div, button': {
      margin: 7
    },
    '& h4, h5': {
      fontWeight: 600,
      color: 'rgba(47, 47, 47)'
    }
  },
  button: {
    backgroundColor: 'rgb(207, 73, 22)',
    padding: 10,
    fontWeight: 600,
    marginLeft: '10px !important',
    '&:hover': {
      backgroundColor: '#aa3c12'
    }
  },
  continueButton: {
    backgroundColor: '#e86838d1',
    padding: 10,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#da5e2f'
    },
    marginTop: 20
  },
  footer: {
    marginTop: 5,
    padding: 35,
    paddingBottom: 40,
    textAlign: 'center',
    backgroundColor: '#f1f4f8',
    borderTop: '4px solid #eeeeee',
    position: 'relative',
    bottom: 0
  },
  sectionLeftContainer: {
    marginRight: 200,
    '& h3, p': {
      marginBottom: 10
    }
  },
  features: {
    '& p': {
      marginTop: 17,
      marginLeft: -5,
      fontWeight: 900,
      color: 'rgba(47, 47, 47, 0.86)',
      fontSize: 17
    },
    '& p svg': {
      marginRight: 10
    }
  }
}));

const getPrice = (upgradePlan, addEngage) => {
  if (upgradePlan && addEngage) {
    return 129;
  } else if (addEngage) {
    return 79;
  } else if (upgradePlan) {
    return 79;
  } else {
    return 49;
  }
}

const LifetimeEngage = () => {
  const [state, setStateFun] = useState({
    upgradePlan: false,
    addEngage: false
  });
  const setState = (obj) => setStateFun({ ...state, ...obj });

  const matches = useMediaQuery('(max-width:1000px)')

  const classes = useStyle();

  const navigate = useNavigate();
  const { lang } = useParams();

  const upgradePlan = JSON.parse(localStorage.getItem('upgradePlan'));
  const user = JSON.parse(localStorage.getItem('user')) || {};

  React.useEffect(() => {
    if (!user.id) navigate(`/${lang}/offer/lifetime`);
  }, [])


  const onSubmit = async () => {
    setState({ saving: true });

    let appName = 'publish', planType = 'personal', currency = 'usd', billingPeriod = 'lifetime';

    if (upgradePlan && state.addEngage) {
      appName = 'publish_manage';
      planType = 'freelancer';
    } else if (state.addEngage) {
      appName = 'publish_manage';
    } else if (upgradePlan) {
      planType = 'freelancer';
    }

    try {
      //https://y3rzqzg5vg.execute-api.ap-south-1.amazonaws.com/dev
      //https://api.postplan.io/auth
      const { data: userData } = await axios.post(`https://api.postplan.io/auth/signup`, {
        name: user.name,
        email: user.email,
        password: Math.random().toString(36).substr(2, 9),
        is_funnel_user: true
      });

      const loginToken = userData.token;

      //https://9dic51w2eh.execute-api.ap-south-1.amazonaws.com/dev
      //https://api.postplan.io/stripe-checkout
      const { data: session } = await axios.get(`https://api.postplan.io/stripe-checkout/create-checkout-session/${appName}/${planType}/${currency}/${billingPeriod}?loginToken=${loginToken}`, {
        headers: {
          'x-auth-token': loginToken
        }
      });

      localStorage.removeItem('user');
      localStorage.removeItem('upgradePlan');

      const stripe = await loadStripe('pk_live_51HkVARLIprUPltei505pl7qNscuIpETD9OL6oldflZ55t8gyaWLCoadyZd5HsBEXLzqha4UL4rDkubsTcJTzGMME00KTU2ZCMb');
      // const stripe = await loadStripe('pk_test_51HkVARLIprUPlteiFjlifobiBKmxpwFYGerRaSHb1cNdqDb2FCFxqZI8fNXLURtnv01ChyU1uPVhxXSfZByv76Wd00cVocJUMV');

      stripe.redirectToCheckout({ sessionId: session.id });
      setState({ saving: false });
    } catch (error) {
      console.log('error', error)
      setState({ saving: false, errorMessage: typeof error?.response?.data === 'string' ? error?.response?.data : 'Something went wrong. Please try again.' })
    }
  }

  return (
    <Grid container style={{ height: '100vh' }}>
      <Grid item xs={12} className={classes.jumbotron}>
        <div className="flex flex-column flex-center flex-middle">
          <div className={classes.logoHolder}>
            <img src="https://images.postplan.io/logo.png" alt="postplan-logo" height="100" />
          </div>
          <Typography variant={matches ? 'h4' : 'h3'} className="text-white">Manage all of your social accounts from Post Plan</Typography>
          <Typography className={classes.subHeading} variant={matches ? 'h6' : 'h5'}>
            Engage and Reply to users’ comments and Schedule Unlimited Comments
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.section}>
        <div className="flex flex-center flex-middle" style={{
          flexDirection: matches ? 'column' : 'row'
        }}>
          <div className={classes.sectionLeftContainer} style={matches ? {
            marginRight: 0,
            alignSelf: 'flex-start'
          } : {}}>
            <Typography variant={matches ? 'h4' : 'h3'} className={classes.sectionLeftHeading}>
              Add the <br /> Engage Plan
            </Typography>
            <Typography style={{ color: 'rgba(47, 47, 47, 0.7)', fontSize: matches ? 18 : 20 }}>
              Benefits of Engage Plan
            </Typography>
            <div className={classes.features}>
              <Typography className="flex flex-middle">
                <CheckIcon /> {upgradePlan ? 12 : 4} Social Media Accounts for Engage
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> All social media feed on one Dashboard
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> Manage & Engage with your users' comments
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> Schedule unlimited comments
              </Typography>
            </div>
          </div>
          <div>
            <div className={classes.formContainer} style={matches ? {
              width: '95vw',
              padding: 15,
              paddingRight: 35,
              marginTop: 20
            } : {}}>
              <Typography variant={matches ? 'h5' : 'h4'}>Don't Miss This Offer</Typography>
              <Typography variant={matches ? 'h6' : 'h5'}>
                Lifetime Access to Engage Plan for just {!upgradePlan ? (
                 <span><del>$599</del> $30</span> 
                ) : (
                  <span><del>$999</del> $50</span> 
                )}
              </Typography>
              <Typography style={{ color: 'red', fontSize: 14 }}>{state.errorMessage}</Typography>
              <Button variant="contained" color="primary" fullWidth className={classes.button} onClick={() => {
                setState({ addEngage: true, errorMessage: '' });
                onSubmit();
              }} disabled={state.saving}>
                Get Publish and Engage Plan for ${upgradePlan ? 129 : 79}
            </Button>
            </div>
            <Button variant="contained" color="primary" fullWidth className={classes.continueButton} onClick={() => {
              setState({ addEngage: false, errorMessage: '' });
              onSubmit();
            }} disabled={state.saving}>
              Continue With Only Publish Plan For ${upgradePlan ? 79 : 49}
            </Button>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.footer}>
        <Typography style={{ color: 'rgba(47, 47, 47, 0.4)', fontSize: 19 }}>
          Copyright @ Post Plan - All Rights Reserved
        </Typography>
      </Grid>
    </Grid>
  );
}

export default LifetimeEngage;